import { ProductViewConfigurator } from '~/types/configurator';
import configuratorChoices from '~/data/configuratorChoices/bagConfiguratorChoices';

export default {
    controls: [
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Material',
            choices: [
                configuratorChoices.materials.customStandard,
                configuratorChoices.materials.kraft,
                configuratorChoices.materials.compostable,
                configuratorChoices.materials.tearResistant,
                configuratorChoices.materials.recyclable,
                configuratorChoices.materials.evoh,
                configuratorChoices.materials.metallic,
            ],
            detailsModalLabel: 'Material options:',
        },
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [
                configuratorChoices.colors.customWhite,
                configuratorChoices.colors.customBrown,
                configuratorChoices.colors.customClear,
            ],
            detailsModalLabel: 'Base color options:',
        },
        {
            key: 'finish',
            keyLabel: 'finish',
            label: 'Finish',
            choices: [
                configuratorChoices.finishes.matte,
                configuratorChoices.finishes.customGloss,
            ],
            detailsModalLabel: 'Finish options:',
        },
        {
            key: 'size',
            keyLabel: 'size',
            label: 'Size',
            choices: [
                { label: '2.25”w × 4”h', value: '2.25-x-4' },
                { label: '3”w × 3”h', value: '3-x-3' },
                { label: '3”w × 3.75”h', value: '3-x-3.75' },
                { label: '3”w × 5”h', value: '3-x-5' },
                { label: '4.82”w × 6”h', value: '4.82-x-6' },
                { label: '6”w × 7”h', value: '6-x-7' },
                { label: '6.25”w × 3”h', value: '6.25-x-3' },
                { label: '7”w × 10”h', value: '7-x-10' },
                { label: '10”w × 12”h', value: '10-x-12' },
            ],
            detailsModalLabel: null,
        },
    ],
} as ProductViewConfigurator;
